// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___vEOoh","container_1":"container_1___3ade0","container_2":"container_2___1rnRa"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/customer-service/styles.module.scss
// module id = 241
// module chunks = 0